import http from 'plugins/axios';

export default {
  getCoinList() {
    return http.get({
      url: '/admin/coin/allDisplay'
    });
  },
  getCurrentList(data) {
    return http.get({
      url: '/admin/current/rate/list',
      data
    });
  },
  createCurrent(data) {
    return http.post({
      url: '/admin/current/rate/add',
      data
    });
  },
  updateCurrent(data) {
    return http.post({
      url: '/admin/current/rate/update',
      data
    });
  }
};
